import * as JitsiConferenceEvents
from 'lib-jitsi-meet/dist/esm/JitsiConferenceEvents';

const SPEECH_DETECT_THRESHOLD = 0.1;
const SpeakerStatsCollector = {
    _onUserJoin(userId) {
        if (this.stats.users[userId]) {
            this.stats.users[userId]._hasLeft = false;
        }
    },
    _audioChanged(id, lvl) {
        const currentUser = this.stats.users[id];

        if (!currentUser.isDominantSpeaker() && lvl > SPEECH_DETECT_THRESHOLD) {
            currentUser.setDominantSpeaker(true);
        }
    },
    _muteChanged(track) {
        if (track.isAudioTrack() && track.isMuted()) {
            const id = track.getParticipantId();
            const currentUser = this.stats.users[id];

            if (currentUser.isDominantSpeaker()) {
                currentUser.setDominantSpeaker(false);
            }
        }
    },
    applyOverride(jitsiConference, conference) {
        conference.addEventListener(JitsiConferenceEvents.USER_JOINED, this._onUserJoin.bind(jitsiConference));

        // conference.addEventListener(JitsiConferenceEvents.TRACK_AUDIO_LEVEL_CHANGED, this._audioChanged.bind(jitsiConference));
        // conference.addEventListener(JitsiConferenceEvents.TRACK_MUTE_CHANGED, this._muteChanged.bind(jitsiConference));
    }
};

export default SpeakerStatsCollector;
